<template>
  <v-card class="view">


    <v-container class="container--fluid header">
      <v-row>
        <v-col cols="4">
          <v-btn class="mr-2 primary" small @click="onClickSelectCart()">ตะกร้า</v-btn>
          <v-chip class="mr-2" color="orange" dark x-small>
            <v-icon left x-small>mdi-star</v-icon>
            แต้ม
          </v-chip>
          <TypeBadge :small="true" :type="order.customer?order.customer.type:null"></TypeBadge>
          {{ order.customer.nickname }}<br/>

          <span>
          ส่ง:
              <span v-if="order.shipping_address_id &&
              order.customer && order.customer.shipping_addresses &&
              order.customer.shipping_addresses.filter(obj=>obj.id===order.shipping_address_id).length>0
              ">
            <span
                v-for="address in order.customer.shipping_addresses.filter(obj=>obj.id===order.shipping_address_id)">
              {{ address.name }}
            {{ address.address }}
          {{ address.district && address.district.name }}
          {{ address.city && address.city.name }}
          {{ address.province && address.province.name }}
              </span>
              </span>
            <span v-else>

            {{ order.customer.address }}
          {{ order.customer.district }}
          {{ order.customer.province }}
              </span>

          <v-btn class="mr-2 primary" x-small @click="onClickSelectAddress()">เปลี่ยน</v-btn></span>

          <CreditBar
              v-if="order.customer"
              :border="1"
              :current="order.customer.debit_amount"
              :fontSize="14"
              :height="24"
              :max="order.customer.credit_amount?order.customer.credit_amount:0"
              :prop_blue="order.customer.debit_pending"
              :prop_green="order.customer.debit_invoice"
              :prop_red="order.customer.debit_overdue"
              :width="200"
              class="mt-2"
          ></CreditBar>
          <div class="caption mt-2" v-if="order.customer">
            วงเงิน คงเหลือ
            {{ number_format(order.customer.credit_amount - order.customer.debit_amount) }} บาท /
            {{ order.customer.credit_amount }} บาท
          </div>
        </v-col>
        <v-col cols="2" class="">
          <v-select
              v-if="order.item_from==OrderConst.ITEM_FROM_OFM"
              v-model="order.price_group"
              :items="[
                      {'value':8,'text':'OFM'},
                      {'value':9,'text':'KCCP'},
                      {'value':10,'text':'KCCP+5%'},
                    ]"
              hide-details
              label="บริษัท"
              outlined
              required
              @change="onOrderChangePriceGroup()"
          ></v-select>
          <v-select
              v-else
              v-model="order.ship_method"
              :items="[
                      {'value':'TS002','text':'ใช่'},
                      {'value':'TS001','text':'ไม่'},
                    ]"
              hide-details
              label="จัดทริป"
              outlined
              required
          ></v-select>
        </v-col>
        <v-col cols="3" class="text-right" >

          <div class="caption">
            ส่ง:

            <v-btn class="delta-text input-text" outlined small tile
                   @click="is_picker_date_delivery=true">
              {{ date_format_short(order.date_delivery) }}

              {{ tDate > 0 ? 'T+' + tDate : '' }}
            </v-btn>
          </div>

          <v-dialog
              v-model="is_picker_date_delivery"
              max-width="308"
              overlay-opacity="0.8"
          >
            <v-card>

              <v-card-text class="pa-2">
                <v-date-picker
                    v-model="date_delivery"
                    locale="th"
                ></v-date-picker>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="is_picker_date_delivery=false">cancel</v-btn>
                <v-btn class="primary" @click="ApplyDateDelivery()">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <div class="caption">
            เวลา:
            <v-btn class="delta-text input-text" outlined small tile
                   @click="openTimeTablePicker(order)"
            >09:00-17:00
            </v-btn>
          </div>
          <div class="caption">
            กลุ่มราคา:
            <v-btn class="delta-text input-text" outlined small tile>
              กลุ่ม{{ PromotionGroupConst.map(order.price_group) }}
            </v-btn>
          </div>
          <!--โทร:-->
          <!--<v-btn class="delta-text input-text" small tile outlined>081 223 5855</v-btn>-->
        </v-col>
        <v-col cols="3">
          <v-textarea
              v-model="order.comment"
              :rules="[max180]"
              height="96px"
              hide-details
              label="หมายเหตุ"
              outlined
              @change="setComment()"
              style="line-height: 16px"
          ></v-textarea>
          <v-checkbox
              style="float: left;width: 80px"
              v-if="order.credit_term===0"
              v-model="order.project_cb3" class="mt-0"
              hide-details
              label="CB3%"
          ></v-checkbox>
          <!--          <span class="comment-ellipsis">{{order.customer.ship_to}}</span>-->
        </v-col>
      </v-row>
    </v-container>
  </v-card>

</template>
<style lang="scss" scoped>
.comment-ellipsis {
  font-size: 14px;
  color: #666;
  line-height: 15px;
  padding-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.header {
  padding: 0 12px;
}

.input-text {
  width: 100px;
  max-width: 60%;
}

@media (min-width: 767px) {
  .input-text {
    width: 150px;
  }
}

.credit-text {
  width: 60px;
}

.credit_selector {
  width: 100%;
  margin-top: 16px;
}

.view {
  /*background: #00FF00;*/
  width: 100%;
  height: 150px;
  display: block;
  /*position: fixed;*/
}

@media (max-width: 768px) {
  .credit-bar {
    display: none;
  }
}

@media (min-height: 700px) {
  .view {
    position: fixed;
    top: 60px;
    z-index: 1;
  }
}


</style>

<script lang="ts">


import {Order, OrderConst} from '@/models/Order'
import {PromotionGroupConst} from '@/models/Promotion'
import {Component, Prop, Vue} from 'vue-property-decorator'
import CreditBar from '../../components/Customer/CreditBar.vue'
import TypeBadge from '../../components/Customer/TypeBadge.vue'

@Component({
  components: {
    TypeBadge, CreditBar
  }
})
export default class HeaderPoint extends Vue {
  @Prop(Number) readonly height: number | undefined
  @Prop() readonly order: Order
  @Prop() readonly onClickSelectCart: () => void
  @Prop() readonly onClickSelectAddress: () => void

  Order = Order
  OrderConst = OrderConst
  date_delivery: string = ''

  PromotionGroupConst = PromotionGroupConst
  is_picker_date_delivery = false

  date_format_short = this.$helper.date_format_short
  number_format = this.$helper.number_format

  get tDate() {
    if (this.order.date_delivery)
      return Math.ceil((new Date(this.order.date_delivery).getTime() - (new Date()).getTime()) / (1000 * 60 * 60 * 24))
    return -1
  }

  mounted() {
    if (this.order.date_delivery) {
      this.date_delivery = new Date(this.order.date_delivery).toISOString().substr(0, 10)
    }
  }

  async onOrderChangePriceGroup() {
    Order.cart_validate(this.order);
    try {
      await Object.setPrototypeOf({
        id: this.order.id,
        mode: 'fill',
        price_group: this.order.price_group,
        item_from: this.order.item_from,
        company: this.order.company
      }, Order.prototype).save()
      Order.cart_on_change_price_group(this.order);
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }
  async onCombineBillChange() {
    try {
      await Object.setPrototypeOf({
        id: this.order.id,
        mode: 'fill',
        combine_bill: this.order.combine_bill,
      }, Order.prototype).save()
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }
  async ApplyDateDelivery() {
    this.order.date_delivery = new Date(this.date_delivery)

    try {
      await Object.setPrototypeOf({
        id: this.order.id,
        mode: 'fill',
        date_delivery: this.date_delivery
      }, Order.prototype).save()
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.is_picker_date_delivery = false
  }

  max180(data) {
    if (data === null || typeof data === 'undefined') {
      return true
    }
    if (data.length > 180) return false
    return true
  }

  async openTimeTablePicker(order: Order) {
    this.$root.$emit('openTimeTablePicker', {
      time_table: order.time_table,
      onApply: time_table => order.time_table = time_table
    })
  }

  async setComment() {
    try {
      await Object.setPrototypeOf({
        id: this.order.id,
        mode: 'fill',
        comment: this.order.comment
      }, Order.prototype).save()
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
  }


}
</script>

